import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import notificationsActions, {
  NotificationOptions,
} from '../redux/modules/notifications/actions';

export type NoteType = NonNullable<NotificationOptions['statusType']>;
export type NotifyFunc = (
  msg: string,
  type: NoteType,
  duration?: NotificationOptions['duration'],
) => void;
type DismissFunc = () => void;

export function useNotify(): [NotifyFunc, DismissFunc] {
  const dispatch = useDispatch();
  return [
    useCallback(
      (
        msg: string,
        type: NoteType,
        duration: NotificationOptions['duration'],
      ) =>
        dispatch(
          notificationsActions.addNotification(msg, {
            statusType: type,
            duration,
          }),
        ),
      [dispatch],
    ),
    useCallback(
      () => dispatch(notificationsActions.removeNotification()),
      [dispatch],
    ),
  ];
}

export default useNotify;
